/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  production: true,
  BASEURL: '',
  BASEURLAPI: '/webapi2',
  WEBCLIENTURL: '/webclient',
  AUTHENTICATIONURL: '/api/account/authenticate',
  FORMSURL: '/api/forms',
  JOBSSEARCHURL: '/api/jobs/search',
  JOBSAVEURL: '/api/jobs',
  JOBTYPESURL: '/api/jobtypes',
  MOBILEUSERSURL: '/api/MobileUsers',
  USERSURL: '/api/users',
  SSRSPROXYURL: '/ssrsproxy',
  JOBTYPEURL: '/api/jobtypes/', //append id to the url
  MENUSURL: '/api/Menus/CurrentUser',
  VIEWSURL: '/api/FilteredView/CurrentUser',
  FILTEREDVIEWURL: '/api/FilteredView/',
  FORMRECORDURL: 'CompletedRecords/search',
  COMPLETEDRECORDURL: 'CompletedRecords',
  REPORTSURL: 'reports',
  NOTIFICATIONHISTORYURL: '/api/NotificationHistory/search',
  NOTIFICATIONHISTORYRESENDURL: '/api/NotificationHistory/Resend',
  NOTIFICATIONHISTORYRESENDBULKURL: '/api/NotificationHistory/ResendBulk',
  NOTIFICATIONHISTORYDELETEURL: '/api/NotificationHistory/Delete',
  NOTIFICATIONURL: '/api/notifications',
  USERGROUPSURL: '/api/UserGroups',
  CHANEPASSWORDURL: '/api/account/changepassword',
  DATAEDITORURL: '/secure/EditFormData.aspx?FormId=',
  BASE_NOMINATIM_URL: 'https://openstreetmap.esayworkmobile.co.uk',
  DEFAULT_VIEW_BOX: 'viewbox=7.715842912499982%2C58.4041727851977%2C-14.168922712499997%2C50.7950163114598',
  PAGESIZE: 50,
  PAGESIZEOPTIONS: [50, 100, 500],
  RESOURCEURL: '/api/Resources/DataLinkSource',
  UPLOADURL: '/api/Resources/UploadDataLinkSource',
  FORGOTPASSWORD: '/api/account/forgotpassword',
  RESETPASSWORD: '/api/Account/forgotpasswordcomplete',
  CHANGEPASSWORDURL: '/api/account/changepassword',
  DOWNLOADURL: '/api/Resources/DownloadDataLinkSource',
  RESOURCESURL: '/api/Resources',
  REPORTSURLFORFORM: 'reports/',
  COLLAGEURL: '/api/MediaAttachments/Collage',
  CATALOGUEUNIQUECOLUMNURL: '/api/catalogues/uniquecolumn',
  CATALOGUEURL: '/api/catalogues',
  CATALOGUEDETAILSBYUSERFORMID: '/api/catalogues/retrievecataloguebyuserformid',
  CATALOGUEDETAILSBYCATALOGUEID: '/api/catalogues/retrievecataloguebycatalogueid',
  UPLOADCATALOGUE: '/api/catalogues/uploadcatalogfile',
  REVISIONHISTORYIFRAMEURL: '/secure/ViewFormRevisions.aspx',
  ACCOUNTVERIFICATION: '/api/account/VerifyAccountRegistration',
  FORGOTMOBILEUSERPASSWORD: '/api/account/forgotmobileuserpassword',
  RESETMOBILEUSERPASSWORD: '/api/account/forgotmobileuserpasswordcomplete',
  APPROVALURL: '/api/approvals/getinboxtotals',
  AUTORELOADINTERVAL: 120,
};
